const locationToggler = document.querySelector(".atd-toggle-location");
const closeLocation = document.querySelector(".atd-close-location-toggle");
const visitStore = document.querySelectorAll(".store-visit");
const toggledLocation = document.querySelector(".atd-toggled-location");
const overlayFooter = document.querySelector(".atd-footer .overlay");

visitStore.forEach((store) => {
  store.addEventListener("click", () => {
    toggledLocation.classList.add("show-location-toggler");
    overlayFooter.classList.add("show-overlay");
  });
});

locationToggler?.addEventListener("click", () => {
  toggledLocation.classList.toggle("show-location-toggler");
  overlayFooter.classList.toggle("show-overlay");
});

overlayFooter?.addEventListener("click", () => {
  toggledLocation.classList.remove("show-location-toggler");
  overlayFooter.classList.remove("show-overlay");
});

closeLocation?.addEventListener("click", () => {
  overlayFooter.classList.remove("show-overlay");
  toggledLocation.classList.remove("show-location-toggler");
});
